import { useNavigate } from "react-router-dom"

function EachDiscussionActivity({title, author,authorID, description,author_image, date,
                            upvote_count, downvote_count, discussion_id,  }) {

  const navigate = useNavigate()

  return (

    <div className='my-8 relative'>
    <div
    onClick={() => {
      navigate(`/profile`, {
                    state: {
                      user_id: authorID
                    }
                  })
    }}
    className="cursor-pointer absolute top-0 right-2 h-[40px] w-[40px] sm:h-[60px] sm:w-[60px]">
                    <img
                    src={author_image}
                    alt="Author's avatar"
                    className={`w-full h-full rounded-full`}
                    />
                </div>

    <div className='w-full'>
    <p className='text-sm font-semibold my-5'>Posted by: {author}</p>

    <div className="my-8">
    <p className=' '>{title}</p>
    <p>{description}</p>
    </div>




    </div>





    {/* <div className={`flex justify-end my-3  ${!text && "mt-10" }`}>
    <Link to={`/discussions/${discussion_id}`}>
        <button className='px-6 sm:px-10 py-2 bg-[#474B7D] hover:bg-[#444770] rounded-md
        text-sm sm:text-[16px]'>Open Discussion</button>
    </Link>
    </div> */}

</div>
  )
}

export default EachDiscussionActivity
